import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CycleService } from '../../../../core/services/cycle.service';
import { RoleService } from '../../../../core/services/role.service';
import { UserService } from '../../../../core/services/user.service';
import { AppDashBloc } from '../../../../core/utils/app-dash-bloc';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../layout/includes/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';


@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule],
    styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
@ViewChild('other_content1') other_content1:any
@ViewChild('other_content2') other_content2:any
@ViewChild('other_content3') other_content3:any
  

  buttonsPermission :any|undefined;
 search_text=""
  structures:any[] =[]
  roles:any[] =[]
  selectedRoles:any[] =[]
  officers:any[] =[]
  data:any[] =[]
  selectedCycles:any[] =[]
  cycles:any[] =[]
  spaces:any[] =[]
  dashTags:any[] =AppDashBloc
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  role_name=""
  role:any
  user:any
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  tag="admin-users"
  
  constructor(
    private userService:UserService,
    private cycleService:CycleService,
    private roleService:RoleService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.user=this.lsService.get(GlobalName.userName)
    this.role=this.user.roles[0].name
    this.spaces=this.lsService.get(GlobalName.features).spaces
    this.init()
    this.buttonsPermission = {
      show:true,
      add:true,
      edit:true,
      delete:true
    };
  }

  init(){
    this.getAll()
  
    this.getRoles()
    this.getCycles()
  }


  getRoles(){
    this.roleService.getAll().subscribe((res:any)=>{
      this.roles=res.data
    },
    (err:any)=>{
    AppErrorShow.showError("Gestion des utilisateurs",err)
    })
  }

  getAll(){
    this.userService.getAll().subscribe((res:any)=>{
      this.data=res.data
      this.pg.p=0
      this.pg.total=res.data.length
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des utilisateurs",err)
    })
  }
  getCycles(){
    this.cycleService.getAll().subscribe((res:any)=>{
      this.cycles=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des utilisateurs",err)
    })
  }


  store(value:any){
    this.loading=true
    if(value.is_signer=="")value.is_signer=false
    console.log(value)
    this.userService.store(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppSweetAlert.simpleAlert("error","Gestion des utilisateurs",err.error.message)
    })
  }

  resetPassword(value:any){
    this.loading=true
    value['id']=this.selected_data.id
    this.userService.resetPassword(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppSweetAlert.simpleAlert("error","Gestion des utilisateurs",err.error.message)
    })
  }
  update(value:any){
    this.loading=true
    if(value.is_signer=="")value.is_signer=false

    this.userService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppSweetAlert.simpleAlert("error","Gestion des utilisateurs",err.error.message)
    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.userService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
        AppSweetAlert.simpleAlert("error","Gestion des utilisateurs",err.error.message)
    })
  }
})
  }
  checked(el?:any){
    this.selectedRoles=[]
    this.selectedCycles=[]
    this.selected_data=el;
    this.selected_data?.roles?.forEach((el:any) => this.selectedRoles.push(el.name));
    this.selected_data?.cycles?.forEach((el:any) => this.selectedCycles.push(el.cycle_id));
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }


  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.userService.setStatus(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
        console.log(err)
          AppSweetAlert.simpleAlert("error","Gestion des utilisateurs",err.error.message)
      })
  }

  getPage(event:any){
    this.pg.p=event
  }


  hasRole(el:any){
    return false;
  }

  filterByRole(ev:any){
    //el.roles.find((el2:any)=>el2.name == ev.target.value)!=undefined ?true:false
     this.data.filter((el:any)=>{
       console.log(ev.target.value);
      return false;
    })
  }

}
